<template>
  <div>
    <div v-if="loadingStarted">
      <Loading></Loading>
    </div>
    <div v-else-if="loadingSuccessful">
      <div class="study-info-subhead font-secondary">
        <span>Study Info</span>
      </div>
      <div class="study-info-content">
        <p class="rich-text-editor-custom-css" v-html="studyInfo" />
      </div>
      <div class="study-info-subhead font-secondary">
        <span>WHY STUDY WAS CREATED</span>
      </div>
      <div class="study-info-content">
        <p>{{ studyPurpose }}</p>
      </div>
      <div class="study-info-subhead font-secondary">
        <span>PARTICIPANTS DESCRIBED THEMSELVES BY GENDER, AGE, AND THESE QUESTIONS</span>
      </div>
      <div class="study-info-content">
        <div v-for="(segmentQuestion, idx) in segmentQuestions" :key="segmentQuestion.id">
          <div>{{ idx + 1 }}. {{ segmentQuestion.question }} Given the following choices:</div>
          <div>{{ segmentQuestion.answers.join(", ") }}</div>
        </div>
      </div>
      <div class="study-info-subhead font-secondary">
        <span>PARTICIPANTS RATED EACH VIGNETTE ON THIS QUESTION:</span>
      </div>
      <div class="study-info-content">
        <span>{{ getRatingQuestion }}</span>
        <span>{{ getRatingScale }}</span>
      </div>
      <div class="study-info-subhead font-secondary">
        <span>THE STUDY WAS LABELLED:</span>
      </div>
      <div class="study-info-content capitalize">
        <p>{{ labels }}</p>
      </div>
      <div class="study-info-subhead font-secondary">
        <span>STUDY QUESTIONS AND ANSWERS</span>
      </div>
      <div class="study-info-content">
        <div v-for="questionAnswer in questionsAndAnswers">
          <div>
            <div>{{ questionAnswer.question }}</div>
            <div>{{ questionAnswer.answers }}</div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="loadingFailed">
      <div class="centered-row">
        <ErrorPage>
          <div slot="header">ERROR</div>
          <div slot="message">Sorry, there was an error loading the page</div>
        </ErrorPage>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GET_BACKEND_URL,
  GET_HTTP_CONFIG,
  LOADING_COMPLETED_FAILURE,
  LOADING_COMPLETED_SUCCESS,
  LOADING_STARTED,
} from "../../services/constants";
import ErrorPage from "./ErrorPage";
import http from "../../services/axios";

export default {
  name: "StudyInfo",
  components: { ErrorPage },
  created() {},

  computed: {
    loadingStatus() {
      return this.$store.state.dataModule.publicStudyInfo.loadingState;
    },
    study() {
      return this.$store.state.dataModule.publicStudyInfo.data;
    },
    loadingStarted() {
      return this.loadingStatus === LOADING_STARTED;
    },
    loadingSuccessful() {
      return this.loadingStatus === LOADING_COMPLETED_SUCCESS;
    },
    loadingFailed() {
      return this.loadingStatus === LOADING_COMPLETED_FAILURE;
    },
    studyInfo() {
      return this.study.surveyParamaters.studyInfo;
    },
    studyPurpose() {
      return this.study.studyPurpose;
    },
    segmentQuestions() {
      return this.study.surveyParamaters.segmentQuestions;
    },
    getRatingQuestion() {
      return this.study.surveyParamaters.ratingQuestions[0].ratingQuestion;
    },
    labels() {
      return this.study.tags.map((tag) => tag["keyword"]).join(", ");
    },
    getRatingScale() {
      let low = this.study.surveyParamaters.ratingQuestions[0].lowEnd;
      let high = this.study.surveyParamaters.ratingQuestions[0].highEnd;
      let maxRating = this.study.surveyParamaters.maxRating;
      return `asked to respond with a number between 1 and ${maxRating} (1 is ${low}, ${maxRating} is ${high})`;
    },
    questionsAndAnswers() {
      return this.study.surveyParamaters.questions.map((question) => {
        let nq = {};
        nq.question = question.question;
        nq.answers = question["answers"].map((answer) => answer["answer"].trim()).join(", ");
        return nq;
      });
    },
  },

  methods: {},
};
</script>

<style scoped lang="scss">
@import "../../scss/main";

.study-info-subhead {
  color: $cyan-blue-3;
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  border-bottom: 1px solid $gray-2;
  margin-right: 60px;
  margin-top: 20px;
  padding-left: 5px;
  padding-bottom: 1px;
}

.study-info-content {
  color: $cyan-1;
  font-size: 14px;
  line-height: 17px;
  margin-top: 4px;
}

.capitalize {
  text-transform: capitalize;
}
</style>
